/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FilterCounts
 */
export interface FilterCounts {
  /**
   *
   * @type {number}
   * @memberof FilterCounts
   */
  counts?: number
}

export function FilterCountsFromJSON(json: any): FilterCounts {
  return FilterCountsFromJSONTyped(json, false)
}

export function FilterCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterCounts {
  if (json === undefined || json === null) {
    return json
  }
  return {
    counts: !exists(json, 'counts') ? undefined : json['counts']
  }
}

export function FilterCountsToJSON(value?: FilterCounts | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    counts: value.counts
  }
}
